import { useState, useEffect } from 'react';
import { fallbackData } from '../utils/fallbackData';

export function useMarketData(coin: string) {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!coin) {
        setIsLoading(false);
        return;
      }

      try {
        const [priceResponse, statsResponse] = await Promise.all([
          fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${coin.toLowerCase()}&vs_currencies=usd&include_24hr_change=true`),
          fetch(`https://api.blockchair.com/${coin.toLowerCase()}/stats`)
        ]);

        if (!priceResponse.ok || !statsResponse.ok) {
          throw new Error('Failed to fetch market data');
        }

        const priceData = await priceResponse.json();
        const statsData = await statsResponse.json();

        const marketData = {
          price: priceData[coin.toLowerCase()]?.usd || fallbackData[coin].price,
          priceChange24h: priceData[coin.toLowerCase()]?.usd_24h_change || 0,
          networkHashrate: statsData.data?.hashrate_24h || fallbackData[coin].networkHashrate,
          blockReward: fallbackData[coin].blockReward,
          blockTime: fallbackData[coin].blockTime,
          difficulty: statsData.data?.difficulty || fallbackData[coin].difficulty
        };

        setData(marketData);
        setError(null);
      } catch (err) {
        console.warn('Using fallback data for', coin, err);
        setData(fallbackData[coin]);
        setError('Using cached market data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // Update every minute
    const interval = setInterval(fetchData, 60000);

    return () => clearInterval(interval);
  }, [coin]);

  return { data, isLoading, error };
}